@if (loading) {
  <div>
    <div class="fui-layout-container">
      <div class="fui-layout-pad-content">
        <myp-skeleton-loader type="line" width="36%" extraContainerClass="m-t-100 m-b-50" height="30px"></myp-skeleton-loader>
        <myp-skeleton-loader type="line" width="98%" extraContainerClass="m-b-10" height="10px"></myp-skeleton-loader>
        <myp-skeleton-loader type="line" width="100%" extraContainerClass="m-b-10" height="10px"></myp-skeleton-loader>
        <myp-skeleton-loader type="line" width="40%" extraContainerClass="m-b-50" height="10px"></myp-skeleton-loader>
      </div>
      <hr />
      <div class="fui-layout-pad-content m-t-50">
        <div class="grid-container even-rows pad-10">
          <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
          <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
          <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
          <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
          <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
          <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
          <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
          <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
        </div>
      </div>
    </div>
  </div>
}

@if (lesson) {
  <div class="fui-layout-container learn-content-details">
    <fui-layout-header [breadcrumbs]="breadcrumbs" [headingText]="lesson.title" [description]="lesson.description" [showDescription]="!isSmallViewport">
      @if (isSmallViewport) {
        <div class="lesson-detail-meta-cta">
          <div class="lesson-detail-meta">
            <div class="lesson-detail-meta-item">
              <fa-icon icon="video"></fa-icon>
              {{ lessonVideoCountLabel }}
            </div>
            @if (lessonRuntimeLabel) {
              <div class="lesson-detail-meta-item">
                <fa-icon icon="clock"></fa-icon>
                {{ lessonRuntimeLabel }}
              </div>
            }
          </div>
          <button class="fui-action-btn sm lesson-detail-library-cta" (click)="toggleSaveLesson(lesson)">
            <fa-icon [animation]="lessonLibraryIconAnimation" [icon]="lessonLibraryIcon"></fa-icon>
            {{ lessonLibraryCtaLabel }}
          </button>
        </div>
        @if (lessonSnippetHtml) {
          <div class="lesson-detail-snippet" [innerHTML]="lessonSnippetHtml | safe: 'html'"></div>
        }
      }
    </fui-layout-header>
    <hr />
    @if (!isSmallViewport) {
      <div class="fui-layout-pad-content">
        <div class="m-y-30 d-flex align-items-center justify-content-between flex-wrap">
          <div class="d-flex align-items-center">
            <div class="m-r-20 m-y-10">
              <fa-icon icon="video"></fa-icon>
              {{ lessonVideoCountLabel }}
            </div>
            @if (lessonRuntimeLabel) {
              <div class="m-r-20 m-y-10">
                <fa-icon icon="clock"></fa-icon>
                {{ lessonRuntimeLabel }}
              </div>
            }
          </div>
          <button class="fui-action-btn sm m-r-10" (click)="toggleSaveLesson(lesson)">
            <fa-icon [animation]="lessonLibraryIconAnimation" [icon]="lessonLibraryIcon"></fa-icon>
            {{ lessonLibraryCtaLabel }}
          </button>
        </div>
      </div>
      <hr />
    }
    <div class="fui-layout-pad-content lesson-detail-body">
      @if (!lesson.subscription_only || user?.active_subscription) {
        <div class="learn-content-percentage">
          <div class="slider" [style.width.%]="lesson.progress"></div>
          <span class="percentage-done">My Progress: {{ lesson.progress }}% Complete</span>
        </div>
      }
      <fui-heading class="lesson-detail-videos-heading" [text]="'Videos In This Lesson'" [level]="2" fontSize="f7"></fui-heading>
      <div class="grid-container wider pad-10">
        @for (video of lesson.videos; track video; let i = $index) {
          <myp-video-grid-item [lessonID]="lesson.id" [showDate]="false" [numbered]="i + 1" [video]="video"></myp-video-grid-item>
        }
      </div>
    </div>
    <div class="p-y-50">
      <fui-footer></fui-footer>
    </div>
  </div>
}
